/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCard/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreditCard({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/PaymentSources/SelectedOption/Autopay/SelectedOption/CreditCard"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let receivableOrganizationIdValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'organization._id',
})
let receivablePaymentAccountPersonPaymentAccountPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'payment_account.person_payment_account.payer_person',
})
let receivablePaymentAccountAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'payment_account.account_type',
})
  return (<React.Fragment
>
<div
  data-testid="CreditCard.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1Gb5Qa': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="card"
 data="receivable.organization._id"
 locationId={receivableOrganizationIdValueData}
 data="receivable.payment_account.person_payment_account.payer_person"
 person={receivablePaymentAccountPersonPaymentAccountPayerPersonValueData}
 data="receivable.payment_account.account_type"
 paymentAccountType={receivablePaymentAccountAccountTypeValueData}
/>
</div>
{children}
</React.Fragment>)
}